/**
 * 错误提示组件
 *
 * 显示错误信息和重试按钮
 */

import React from 'react';

interface ErrorMessageProps {
  /** 错误消息 */
  message: string;
  /** 重试回调函数 */
  onRetry?: () => void;
  /** 自定义类名 */
  className?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  onRetry,
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      <div className="text-red-500 mb-4">
        <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">加载失败</h3>
      <p className="text-gray-700 text-center mb-4 max-w-md">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-gray-900 text-gray-50 rounded-lg hover:bg-gray-800 transition-colors"
          aria-label="重试"
        >
          重试
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;